  <ul class="d-flex align-items-center list-unstyled mb-0">
    <li class="clickable withOpacity d-lg-inline-block me-3 my-2" (click)="setVisibleType('')"><input type="radio" [checked]="selected === ''">
      {{'ALL'|translate}}</li>
    <li class="clickable withOpacity d-lg-inline-block me-3 my-2" (click)="setVisibleType('parts')"><input type="radio"
      [checked]="selected === 'parts'"> {{'PARTS'|translate}}</li>
    <li class="clickable withOpacity d-lg-inline-block me-3 my-2" (click)="setVisibleType('bicycles')"><input type="radio"
      [checked]="selected === 'bicycles'"> {{'BIKES'|translate}}</li>
  </ul>
